import React from 'react'
import Helmet from 'react-helmet'
import {
  BannerImageSection,
  FAQSection,
  FoodBoxSection,
  GoustoValueSection,
  GoustoWorthSection,
  HeroSection,
  HowItWorksSection,
  TestimonialSection,
  WhyChooseGoustoSection,
} from '../../sections'
import type { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { SEO } from './config'

export function HowGoustoFoodBoxesWorkPage({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <>
      <Helmet title={SEO.head.title} meta={SEO.head.meta}>
        <meta property="og:title" content={SEO.head.title} />
        <meta property="og:description" content={SEO.head.meta[0].content} />
      </Helmet>
      <HeroSection startOnboarding={startOnboarding} />
      <BannerImageSection />
      <FoodBoxSection startOnboarding={startOnboarding} />
      <HowItWorksSection startOnboarding={startOnboarding} />
      <WhyChooseGoustoSection startOnboarding={startOnboarding} />
      <GoustoValueSection startOnboarding={startOnboarding} />
      <TestimonialSection />
      <FAQSection startOnboarding={startOnboarding} />
      <GoustoWorthSection startOnboarding={startOnboarding} />
    </>
  )
}
